import { Injectable } from '@angular/core';
import {
  TasksService,
  TaskFilter,
  DateRangeFilter,
  OrderType,
  TaskType,
} from '@compumark/analyst-selection-tool-client';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ExportOptionsService {
  readonly reviewDate = 'REVIEW_DATE';
  readonly deliveryDate = 'DELIVERY_DATE';

  constructor(private tasksService: TasksService) {}

  exportToXlsx(
    dateValue: any,
    operator: string,
    fromDate: Date | null,
    toDate: Date | null,
  ): Observable<Blob> {
    const taskFilter: TaskFilter = {
      orderType: [OrderType.OPSI],
      taskType: [TaskType.SELECTION],
    };
    if (dateValue === this.reviewDate) {
      taskFilter.reviewDateRange = this.buildDateRange(
        operator,
        fromDate,
        toDate,
      );
      taskFilter.taskType = [TaskType.SELECTION, TaskType.QUALITY];
    } else if (dateValue === this.deliveryDate) {
      taskFilter.deliveryDate = this.buildDateRange(operator, fromDate, toDate);
      taskFilter.taskType = [
        TaskType.SELECTION,
        TaskType.CCLA,
        TaskType.COPYRIGHT,
        TaskType.TITLE,
      ];
    }

    return this.tasksService.exportSearchesToCsv(taskFilter);
  }

  private startOfDay(d: Date): Date {
    const copy = new Date(d);
    copy.setHours(0, 0, 0, 0);
    return copy;
  }

  private endOfDay(d: Date): Date {
    const copy = new Date(d);
    copy.setHours(23, 59, 59, 999);
    return copy;
  }

  buildDateRange(
    operator: string,
    from: Date | null,
    to: Date | null,
  ): DateRangeFilter | undefined {
    if (!from) {
      return;
    }

    const start = this.startOfDay(from);
    const end = to ? this.endOfDay(to) : null;

    switch (operator) {
      case 'equals':
        return {
          startDate: start.toISOString(),
          endDate: this.endOfDay(from).toISOString(),
        };

      case 'greaterThan':
        return { startDate: this.endOfDay(from).toISOString() };

      case 'lessThan':
        return { endDate: this.endOfDay(from).toISOString() };

      case 'inRange':
        if (!end) {
          return;
        }
        return {
          startDate: start.toISOString(),
          endDate: end.toISOString(),
        };

      default:
        return undefined;
    }
  }

  triggerXLSXFileDownload(blob: Blob, prefix: string): void {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    const iso = new Date().toISOString();
    const timestamp = iso.substring(0, 16).replace(/[:]/g, '-');
    link.href = url;
    link.download = `${prefix}-${timestamp}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }
}
